import { TRIAL_WORDS_LIMIT } from 'src/data/subscription';
import { useCurrentCustomer } from 'src/store';

export const useTrialWordsLimit = () => {
  const currentCustomer = useCurrentCustomer();
  return currentCustomer?.billingConfiguration?.queryQuota?.planWordsLimit || TRIAL_WORDS_LIMIT;
};
